import React from 'react';

const PLACEHOLDER_PATRON = /\{(nombreEvento|linkAvisoPrivacidad)\}/g;

// Convierte el texto crudo (con placeholders "{nombreEvento}"/"{linkAvisoPrivacidad}"
// sin sustituir y saltos de línea reales, como lo escribió el admin en el
// textarea) a JSX: cada placeholder se reemplaza por su valor envuelto en
// <b> (las variables van en negritas, igual que en el texto por defecto), y
// cada salto de línea por <br/>.
function renderTextoConVariables(texto, valores) {
  const partes = [];
  let key = 0;

  const agregarConSaltos = (fragmento) => {
    fragmento.split("\n").forEach((linea, i, arr) => {
      partes.push(<React.Fragment key={key++}>{linea}</React.Fragment>);
      if (i < arr.length - 1) partes.push(<br key={key++} />);
    });
  };

  let ultimoIndex = 0;
  let match;
  PLACEHOLDER_PATRON.lastIndex = 0;
  while ((match = PLACEHOLDER_PATRON.exec(texto)) !== null) {
    agregarConSaltos(texto.slice(ultimoIndex, match.index));
    partes.push(<b key={key++}>{valores[match[1]] || ""}</b>);
    ultimoIndex = PLACEHOLDER_PATRON.lastIndex;
  }
  agregarConSaltos(texto.slice(ultimoIndex));

  return partes;
}

const DisclaimerResponsabilitiesHTML = (
  { eventDetail, registryParticipantDataConfirm, registryConfiguration, more18 }) => {

  let eventName = eventDetail.nombreEvento;
  let linkPrivacyPolicy = eventDetail.organizador.linkAvisoPrivacidad;
  let nameLastnameAtlete = registryParticipantDataConfirm.nombres + " " + registryParticipantDataConfirm.apellidos;

  let raceNumber = 0;
  if (registryParticipantDataConfirm.numero != undefined) {
    raceNumber = registryParticipantDataConfirm.numero;
  }

  // Textos guardados por el admin en inscripcionesConfiguracion.deslindeResponsabilidades
  // (tab "Deslinde de responsabilidades" de Configuración), crudos (con los
  // placeholders sin sustituir — eso lo hace renderTextoConVariables). Si no
  // hay override guardado, se usa el párrafo por defecto de siempre, sin
  // cambios. El aviso de privacidad es un solo texto compartido entre
  // mayores/menores (el párrafo legal central sí es uno por edad).
  const deslindeConfig =
    (registryConfiguration && registryConfiguration.deslindeResponsabilidades) || {};
  const textoPersonalizadoCrudo = !more18
    ? deslindeConfig.textoMenores
    : deslindeConfig.textoMayores;
  const textoAvisoCrudo = deslindeConfig.textoAviso;
  const valoresPlaceholders = {
    nombreEvento: eventName || "",
    linkAvisoPrivacidad: linkPrivacyPolicy || "",
  };

  if (!more18) {
    return (
      <div>
        <p>

          {textoAvisoCrudo ? renderTextoConVariables(textoAvisoCrudo, valoresPlaceholders) : (<>
            Es indispensable presentar este comprobante impreso y una copia de tu Credencial de Elector para poder recoger tu Kit de participante. El aviso de privacidad se puede consultar en {linkPrivacyPolicy}
          </>)}
          <br />
          <br />
          Al realizar mi inscripción en este evento declaro que me encuentro en plena capacidad física para participar en el mismo y deslindo de cualquier responsabilidad a las empresas organizadoras y patrocinadoras así como a sus representantes, de cualquier lesión o accidente como consecuencia de mi participación en el evento.
          <br />
          <br />
          {textoPersonalizadoCrudo ? renderTextoConVariables(textoPersonalizadoCrudo, valoresPlaceholders) : (<>
            CARTA RESPONSIVA PARA MENORES DE 18 AÑOS: Yo, el abajo firmante, como padre, madre o tutor del menor que estamos inscribiendo al evento <b>{eventName}</b>, declaro por esta misiva, por el sólo hecho de firmar este documento, acepto cualquier y todos los riesgos y peligros que sobre el/la niño/a recaigan en cuanto a su participación en el evento antes referido en adelante el "Evento". Por lo tanto, yo soy el único responsable de conocer su estado de salud, su condición física, preparación, capacidad, cualquier consecuencia, accidentes, perjuicios, deficiencias que puedan causar, de cualquier manera posible alteraciones a su salud, integridad física, o inclusive la muerte, así como soy y seré responsable los gastos totales que se generen por causa de algún accidente en competencia. Yo, el abajo firmante, seré siempre responsable de los accidentes que llegara a sufrir el niño o niña competidor inscrito, ya que declaro que estoy en pleno conocimiento de los riesgos y peligros inherentes en las áreas del evento o participando en este, por lo que por esa razón libero de cualquier responsabilidad al respecto a las instalaciones del lugar, los dueños del lugar donde se realiza la competencia, a las personas, clubes, grupos, a las Asociaciones que la integran y/o a la Empresa / Comité Organizador, sus directores, patrocinadores, accionistas, representantes, directores financieros y consejeros de las compañías, y por medio de este conducto renuncio, sin limitación alguna a cualquier derecho, demanda o indemnización al respecto. Además, no serán responsables por cualquier desperfecto, pérdida o robo relacionados con las pertenencias personales del niño o niña. Así mismo, autorizó al Comité organizador y/o a quien ésta designe el uso de la imagen y voz del niño/a, ya sea parcial o totalmente, en cuanto a todo lo relacionado en el Evento, de cualquier manera y en cualquier momento. Por este conducto reconozco que sé y entiendo todas las regulaciones del Evento, incluyendo y sin limitarse en lo general, así como en lo particular al reglamento interior de competencia. Igualmente, manifiesto bajo protesta de decir verdad que el equipo de competencia reúne y cumple con todos los requisitos reglamentarios aplicables, sin perjuicio de la facultad que se tenga para revisar dicho equipo y los demás establecidos en la mencionada normatividad.
          </>)}
          <br />
          <br />
          Tipo de ID ______________________  Número: <b>{raceNumber}</b>
          <br />
          Atleta representado: <b>{nameLastnameAtlete}</b>
          <br />

          _________________________________________________________
          <br />
          Nombre Completo del Padre o Tutor (escrito a mano)
          <br />
          _________________________________________________________
          <br />
          Firma
          EN TESTIMONIO DE FE, COMO RESPONSABLES DEL COMPETIDOR INSCRITO, NOSOTROS COMO PADRES O TUTORES, DECLARAMOS HABER ENTENDIDO LO ANTERIORMENTE DESCRITO Y AÑADIMOS LA FIRMA EN FORMA VOLUNTARIA.
        </p>
      </div>);
  }
  return (<div>
    <p>

      {textoAvisoCrudo ? renderTextoConVariables(textoAvisoCrudo, valoresPlaceholders) : (<>
        Es indispensable presentar este comprobante impreso y una copia de tu Credencial de Elector para poder recoger tu Kit de participante. El aviso de privacidad se puede consultar en {linkPrivacyPolicy}
      </>)}
      <br /><br />
      Al realizar mi inscripción en este evento declaro que me encuentro en plena capacidad física para participar en el mismo y deslindo de cualquier responsabilidad a las empresas organizadoras y patrocinadoras así como a sus representantes, de cualquier lesión o accidente como consecuencia de mi participación en el evento.
      <br /><br />
      {textoPersonalizadoCrudo ? renderTextoConVariables(textoPersonalizadoCrudo, valoresPlaceholders) : (<>
        EXONERACIÓN: Yo, participante inscrito al evento denominado <b>{eventName}</b>, por el sólo hecho de firmar este documento, acepto cualquier y todos los riesgos y peligros que sobre mi persona recaigan en cuanto a mi participación en el evento antes referido en adelante el "Evento". Por lo tanto, yo soy el único responsable de mi condición física, preparación, capacidad, mi salud, cualquier consecuencia, accidentes, perjuicios, deficiencias que puedan causar, de cualquier manera posible alteraciones a mi salud, integridad física, o inclusive la muerte, así como soy y seré responsable de los gastos totales que se generen por causa de algún accidente en competencia a mi persona. Por esa razón libero de cualquier responsabilidad al respecto a las instalaciones del lugar, los dueños del lugar donde se realiza la competencia, a las personas, clubes, grupos, a las Asociaciones que la integran y/o a la Empresa / Comité Organizador, sus directores, patrocinadores, accionistas, representantes, directores financieros y consejeros de las compañías, y por medio de este conducto renuncio, sin limitación alguna a cualquier derecho, demanda o indemnización al respecto. También reconozco y acepto que todas las personas y entidades referidas en el último párrafo no son ni serán consideradas responsables por la protección y custodia de mis pertenencias personales; Además, no serán responsables por cualquier desperfecto, pérdida o robo relacionados con mis pertenencias personales. Autorizó al Comité organizador y/o a quien ésta designe el uso de mi imagen y voz, ya sea parcial o totalmente, en cuanto a todo lo relacionado en el Evento, de cualquier manera y en cualquier momento. Por este conducto reconozco que sé y entiendo todas las regulaciones del Evento, incluyendo y sin limitarse en lo general, así como en lo particular al reglamento interior de competencia. Igualmente, manifiesto bajo protesta de decir verdad que mi equipo de competencia reúne y cumple con todos los requisitos reglamentarios aplicables, sin perjuicio de la facultad que se tenga para revisar dicho equipo y los demás establecidos en la mencionada normatividad.
      </>)}
      <br /><br />
      Tipo de ID ______________________  Número: <b>{raceNumber}</b>
      <br />
      <br />
      _________________________________________________________
      <br />
      <b>Firma {nameLastnameAtlete}</b>
      <br />
    </p>
  </div>);
}

export default DisclaimerResponsabilitiesHTML;
